// extracted by mini-css-extract-plugin
export default {"classes":"ServiceTerms_classes__Qldu8","btnDiv":"ServiceTerms_btnDiv__RefbM","bgGreen":"ServiceTerms_bgGreen__26EG9","bgRed":"ServiceTerms_bgRed__LAtDx"};